import type { ReactNode } from "react";
import { useDesignV2 } from "./designV2Store";
import { RedesignContext } from "./useRedesign";

/** One presentation decision for the shell, viewer and theme: this browser's choice, else the
 *  project's `design_v2` flag (`designV2Store.ts`). */
export function RedesignProvider({ children }: { children: ReactNode }) {
    const enabled = useDesignV2();
    return <RedesignContext.Provider value={{ enabled }}>{children}</RedesignContext.Provider>;
}
